import { useEffect, useRef } from 'react';

// Expandable multi-line brief with a live character count. Nothing is cut off: going over the limit is shown in red
// and the caller disables sending, so the full description always reaches the backend.
export const PROMPT_LIMIT = 4000;

export function PromptBox({ value, onChange, disabled, placeholder, testid, limit = PROMPT_LIMIT, minRows = 4 }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight + 2, 420)}px`;
  }, [value]);
  const over = value.length > limit;
  return (
    <div className="space-y-1">
      <textarea ref={ref} data-testid={testid} rows={minRows} value={value} disabled={disabled} placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full min-h-[7rem] resize-y rounded-sm border bg-background px-3 py-2 text-sm leading-relaxed shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:opacity-50 ${over ? 'border-red-400' : 'border-input'}`} />
      <p data-testid={`${testid}-count`} className={`text-right text-[11px] ${over ? 'text-red-600 font-medium' : 'text-muted-foreground'}`}>
        {value.length.toLocaleString()} / {limit.toLocaleString()}{over ? ' · please shorten to send' : ''}
      </p>
    </div>
  );
}
